import { InputCurrencyComponent } from './input-currency.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from '../../../pipe/pipe.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [InputCurrencyComponent],
  exports: [InputCurrencyComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class InputCurrencylModule { }
